import {
  defaultTtsVoice,
  Design,
  DesignFillerPrompt,
  LanguageCode,
  TextToSpeechVoiceOrDefault
} from '../../../types';
import { getGlobalSettings } from '../../../stores';

export type GetFillerPromptTextProps = {
  languageCode?: LanguageCode;
  prompt: DesignFillerPrompt;
  serialized?: Design;
  ttsVoice?: TextToSpeechVoiceOrDefault;
};

export function getFillerPromptText({
  languageCode,
  prompt,
  serialized,
  ttsVoice
}: GetFillerPromptTextProps): string {
  const { language, ...globalSetings } = getGlobalSettings();
  languageCode ??= language as LanguageCode;
  ttsVoice ??= globalSetings.ttsVoices?.[languageCode] ?? defaultTtsVoice;
  serialized ??= window.apm.serialized;
  const { ttsOverrides } = serialized.rootSettings.features;

  if (ttsOverrides && ttsVoice && ttsVoice !== defaultTtsVoice) {
    const text = prompt?.ttsOverrides?.[languageCode]?.[ttsVoice]?.text;
    if (text) {
      return text;
    }
  }
  return prompt.transcripts.find(({ locale }) => {
    return locale === languageCode;
  })?.transcript ?? '';
}
